<div #headerContainer>
  <div
    *ngIf="menu | productMenuBasicMethod: 'getSectionTitle' : section | exists"
    class="section-title"
    [style.background-color]="section?.metadata?.productsHeaderBackgroundColor"
    [style.color]="section?.metadata?.sectionHeaderTextColor"
    [style.background-size]="'cover'"
    [style.zoom]="menu?.menuOptions?.productZoom || 1.0">
    <div class="section-title-text">{{ menu | productMenuBasicMethod: 'getSectionTitle' : section }}</div>
  </div>
  <div
    class="section-header-container"
    [style.background-color]="section?.metadata?.productsHeaderBackgroundColor"
    [style.zoom]="menu?.menuOptions?.productZoom || 1.0"
    [style.border-bottom-color]="menu | productMenuBasicMethod: 'getSectionTitleUnderlineColor' : section">
    <ng-container *ngFor="let col of columnVMs">
      <div
        *ngIf="menu | getShouldInflateColumnHeaderForRow: section : col : sectionRowViewModels"
        class="section-column"
        [ngClass]="{ 'section-column-title': col.columnType === Types.SectionColumnProductInfoType.ProductTitle }"
        [style.width.%]="col.widthPercentage"
        [style.color]="menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section"
        [hidden]="menu | getShouldHideHeaderContent: section : col">
        @if (col.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
          <app-header-column-variant-price [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
          <app-header-column-variant-secondary-price [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Stock) {
          <app-header-column-quantity-in-stock [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Quantity) {
          <app-header-column-quantity [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.ProductTitle) {
          <div
            appScaleDownText
            [style.color]="menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section"
            [scaleEnabled]="!(menu | isPrintMenu)"
            class="section-header-general section-header-product-title">
            Product Name
          </div>
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Size) {
          <app-header-column-size [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Strain) {
          <app-header-column-strain [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.StrainType) {
          <app-header-column-strain-type [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Lineage) {
          <app-header-column-lineage [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col?.columnType | isCannabinoidColumn) {
          <app-header-column-cannabinoid
            [menu]="menu"
            [section]="section"
            [colVm]="col"
            [sectionRowViewModels]="sectionRowViewModels"
            [cannabinoidColumnType]="col?.columnType | isCannabinoidColumn" />
        } @else if (col?.columnType | isTerpeneColumn) {
          <app-header-column-terpene
            [menu]="menu"
            [section]="section"
            [colVm]="col"
            [sectionRowViewModels]="sectionRowViewModels"
            [terpeneColumnType]="col?.columnType | isTerpeneColumn" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Producer) {
          <app-header-column-producer [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Badge) {
          <app-header-column-badge [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.Brand) {
          <app-header-column-brand [menu]="menu" [section]="section" [colVm]="col" />
        } @else if (col.columnType === Types.SectionColumnProductInfoType.GradingResults) {
          <app-header-column-grading-results-score [menu]="menu" [section]="section" [colVm]="col" />
        }
      </div>
    </ng-container>
  </div>
</div>
